export const AddressState = Object.freeze({
  empty: "empty",
  error: "error",
  invalid: "invalid",
  valid: "valid",
});
